import React from 'react';
import moment from 'moment';
import { connect } from 'react-redux';
import * as MaterialUI from 'material-ui';
import FontAwesome from 'react-fontawesome';
import { Row, Col } from 'reactstrap';

import * as generalActions from 'modules/general/action';
import * as registrosAction from '../action';
import { traducirAccion } from 'core/generalFunctions';

@connect(store => ({
  logs: store.getIn(['registros', 'logs']),
  logsFiltered: store.getIn(['registros', 'logsFiltered']),
  actionFilter: store.getIn(['registros', 'actionFilter']),
  loading: store.getIn(['general', 'loadingbar', 'show'])
}))
export default class extends React.Component {
  componentDidMount = () => {
    this.props.dispatch(generalActions.dashboard_changeTitle('Actividad en el sistema'));
    this.props.dispatch(registrosAction.getLogs(moment()));
  }
  filterAction = accion => {
    this.props.dispatch(registrosAction.setState({ actionFilter: accion }));
    this.props.dispatch(registrosAction.filterLogsByAction(accion));
  }
  changeDay = (fecha) => {
    this.props.dispatch(registrosAction.clear('logs'));
    this.props.dispatch(registrosAction.clear('actionFilter'));
    this.props.dispatch(registrosAction.clear('logsFiltered'));
    this.props.dispatch(registrosAction.getLogs(moment(fecha)));
  }
  getMore = () => {
    this.props.dispatch(registrosAction.getLogs(moment(this.refs.diaViaje ? this.refs.diaViaje.state.date : undefined ), this.props.logs.size));
  }
  componentWillUnmount = () =>{
    this.props.dispatch(registrosAction.clear('logs'));
    this.props.dispatch(registrosAction.clear('logsFiltered'));
    this.props.dispatch(registrosAction.clear('actionFilter'));
  }
  render() {
    const { logs, actionFilter, logsFiltered, loading } = this.props,
          accionesLogs = logs.groupBy( log => log.get('accion')).map( (item,name) => <MaterialUI.MenuItem value={name} primaryText={traducirAccion(name).accion} />);
    let logsLista = logsFiltered.size > 0 ? logsFiltered : logs;
    return (
      <div>
        <Row className="rowContainer">
          <Col lg={{ size: 8, offset: 2 }} md="12">
            <Row className="mb-20">
              <MaterialUI.Paper zDepth={2} className="container p10">
                <Row>
                  <Col md='3' className="pt-10">
                    <p><b> Actividad del dia {moment(this.refs.diaViaje ? this.refs.diaViaje.state.date : undefined ).format('DD/MM/YYYY')}</b></p>
                  </Col>
                  <Col md='3'>
                    <MaterialUI.RaisedButton
                      label='Cambiar dia'
                      onTouchTap={() => this.refs.diaViaje.focus()}
                      secondary={true}
                      fullWidth={true}
                    />
                    <MaterialUI.DatePicker
                      name='diaViaje'
                      ref="diaViaje"
                      className='hidden'
                      autoOk
                      onChange={ (val,fecha) => this.changeDay(fecha)}
                    />
                  </Col>
                  <Col md='2' className="pt-10">
                    <p><b> Filtrar por accion </b></p>
                  </Col>
                  <Col md="3">
                    <MaterialUI.SelectField
                      name="accionFiltro"
                      onChange={(e, val, accion) => this.filterAction(accion)}
                      value={actionFilter}
                    >
                      <MaterialUI.MenuItem value={null} primaryText={'Sin filtros'} />
                      {accionesLogs}
                    </MaterialUI.SelectField>
                  </Col>
                </Row>
              </MaterialUI.Paper>
            </Row>
            <Row>
              <MaterialUI.Paper zDepth={2} className="container">
                <MaterialUI.List className="noPadding">
                  <MaterialUI.ListItem
                    disabled
                    className="noMargin"
                    primaryText={
                      <Row className="listIcon p-lr-10">
                        <Col md="2" />
                        <Col md="4" className="pt-10"> <p><b> Acción </b></p> </Col>
                        <Col md="3" className="pt-10">
                          <p><b><FontAwesome name="clock-o" /> Fecha y hora </b></p>
                        </Col>
                        <Col md="3" className="pt-10"> <p><b>Autor de la acción</b></p> </Col>
                      </Row>
                    }
                  />
                  <MaterialUI.Divider />
                  {logsLista.map( (log, i) => {
                    const userData = log.get('_usuario'),
                    accionTraducida = traducirAccion(log.get('accion'));
                    return <div key={i}><MaterialUI.ListItem
                      disabled
                      className="noMargin"
                      primaryText={
                        <Row className="listIcon p-lr-10">
                          <Col md="2" className={accionTraducida.color}><FontAwesome name={accionTraducida.icon} /></Col>
                          <Col md="4" className="pt-10">{ accionTraducida.accion }</Col>
                          <Col md="3" className="pt-10">
                            <FontAwesome name="clock-o" />  {moment(log.get('fecha')).format('DD/MM/YYYY HH:mm')}
                          </Col>
                          { userData && <Col md="3" className="pt-10"> {userData.get('nombre')} {userData.get('apellido')}</Col> }
                      </Row>
                    }
                  /><MaterialUI.Divider /></div>; }
                )}
              </MaterialUI.List>
            </MaterialUI.Paper>
            </Row>
          </Col>
          <MaterialUI.FloatingActionButton
            disabled={loading}
            className="bottonFlotanteAdd"
            onTouchTap={() => this.getMore()}>
            <FontAwesome name="arrow-down" />
          </MaterialUI.FloatingActionButton>
        </Row>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// src/modules/registros/components/logs.js